<template>
  <!-- 饼状图 -->
  <div :class="className" ref="pan" :style="{ height: height, width: width }"></div>
</template>

<script>
import echarts from "echarts";
import { deepClone } from "@/assets/js/utils"
require("echarts/theme/macarons");
export default {
  props: {
    className: {
      type: String,
      default: "chat",
    },
    title: {
      type: String,
      default: "chat",
    },
    MeetingStat: {
      type: Object,
      default: {},
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
  },
  data(){
    return{
      delay:false
    }
  },
  watch: {
    MeetingStat: function (val) {
      this.initmeeting_echarts(val);
    },
  },
  created(){
    const that = this
    window.addEventListener("resize", function () {
      if (that.delay) {
        clearTimeout(that.delay);
      }
      that.delay = setTimeout(function () {
        that.initmeeting_echarts(that.MeetingStat);
      }, 50);
    });
  },
  methods: {
    initmeeting_echarts(options) {
      //var myChart = echarts.init(this.$el, "macarons");
      var myChart = echarts.init(this.$refs.pan);
      myChart.resize()
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: this.title,
            type: "pie",
            radius: "85%",
            label: {
              position: "inner",
              fontSize: 14,
            },
            data: options.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      var that = this;
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.meeting_Stat {
  height: 176px;
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts/PieChat.vue